export default class TagsCtrl {
    constructor($scope, $state, $timeout, $rootScope, SideMenu, Rest, Tag, Segment) {
        SideMenu.setActive('tag');

        this._state = $state;
        this._scope = $scope;
        this._timeout = $timeout;

        this.segmentRepo = Segment;
        this.tagRepo = Tag;

        this.status = this._state.current.name == 'filter.index' ? 'filters' : 'tags';
        this.search = "";
        this.currentPage = 1;
        this.searchTimeout = false;
        this.usePagination = true;

        this._scope.$watch(() => this.currentPage, (newVal) => {
            if (newVal) {
                this.setPage();
            }
        });
    }

    setStatus(status) {
        if (status != this.status) {
            if (status == 'filters') {
                this._state.go('filter.index');
            } else if (status == 'tags') {
                this._state.go('tag.index');
            }
        }
    };

    setPage() {
        if (this.status == "filters") {
            this.segmentRepo.all(this.currentPage, this.usePagination).then((filters) => {
                this.filters = filters.data;
                this.metaData = filters.meta.pagination;

                this.segmentRepo.countSubscribers(this.currentPage).then((filters) => {
                    if (this.search == "") {
                        this.filters = filters.data;
                    }
                });
            });
        } else {
            this.tagRepo.all(this.currentPage, this.usePagination, ['count_subscribers']).then((tags) => {
                this.tags = tags.data;
                this.metaData = tags.meta.pagination;
            });
        }
    };

    searchTagsAndFilters() {
        this.currentPage = 1;

        if (this.searchTimeout) {
            this._timeout.cancel(this.searchTimeout);
        }

        this.searchTimeout = this._timeout(() => {
            if (this.search == "") {
                this.setPage();
            } else {
                var searchValue = this.search; // to check cases if search was updated, if so - discard response result

                if (this.status == 'tags') {
                    this.tagRepo.searchTags(this.search, this.currentPage).then((response) => {
                        if (this.search === searchValue) {
                            this.tags = response.data;
                            this.metaData = response.meta.pagination
                        }
                    })
                } else {
                    this.segmentRepo.searchFilters(this.search).then((response) => {
                        if (this.search === searchValue) {
                            this.filters = response;
                            this.metaData.total = this.metaData.per_page = this.searchCount = response.length;
                        }
                    })
                }
            }
        }, 500);
    };

    clearSearch() {
        this.search = "";
        this.searchCount = 0;
        this.currentPage = 1;
        this.tags = [];
        this.filters = [];
        this.setPage();
    };

    createFilter() {
        this._state.go('filter.create');
    }
};
